/**
 * NUCLEAR OPTION - Absolute blocking with detailed logging
 * FIXED: Now ignores Quick View forms to prevent conflict
 * ENHANCED: Now handles Buy Now buttons
 */

(function() {
  'use strict';
  
  console.log('🚨 NUCLEAR SIZE VALIDATION LOADED (Quick View aware + Buy Now support)');
  
  // Helper function to check if element is inside Quick View
  function isInsideQuickView(element) {
    return element.closest('quickbuy-canvas, .quick_shop-popup, [class*="quickview"]') !== null;
  }
  
  // Helper function to validate size selection
  function validateSizeSelection() {
    // Find ALL size-related elements on the page (EXCLUDING Quick View)
    const allSizeInputs = Array.from(document.querySelectorAll('input[name="Size"]'))
      .filter(input => !isInsideQuickView(input));
    const allSizeSelects = Array.from(document.querySelectorAll('select[name*="Size"]'))
      .filter(select => !isInsideQuickView(select));
    
    console.log('🔍 Found size inputs (excluding Quick View):', allSizeInputs.length);
    console.log('🔍 Found size selects (excluding Quick View):', allSizeSelects.length);
    
    let hasSizeOption = false;
    let sizeSelected = false;
    
    // Check radio buttons
    if (allSizeInputs.length > 0) {
      hasSizeOption = true;
      console.log('📋 Product HAS size option (radio buttons)');
      
      allSizeInputs.forEach((input, index) => {
        console.log(`  Input ${index}:`, {
          value: input.value,
          checked: input.checked,
          disabled: input.disabled,
          visible: input.offsetParent !== null
        });
        
        if (input.checked && !input.disabled) {
          sizeSelected = true;
          console.log(`  ✅ This input is CHECKED: ${input.value}`);
        }
      });
    }
    
    // Check dropdown
    if (allSizeSelects.length > 0) {
      hasSizeOption = true;
      console.log('📋 Product HAS size option (dropdown)');
      
      allSizeSelects.forEach((select, index) => {
        console.log(`  Select ${index}:`, {
          value: select.value,
          disabled: select.disabled,
          visible: select.offsetParent !== null
        });
        
        if (select.value && select.value !== '' && select.value !== 'Please select a size' && !select.disabled) {
          sizeSelected = true;
          console.log(`  ✅ This select has value: ${select.value}`);
        }
      });
    }
    
    console.log('📊 VALIDATION RESULT:');
    console.log('  Has size option:', hasSizeOption);
    console.log('  Size selected:', sizeSelected);
    
    return {
      hasSizeOption: hasSizeOption,
      sizeSelected: sizeSelected,
      needsValidation: hasSizeOption && !sizeSelected
    };
  }
  
  // LAYER 1: Intercept fetch with DETAILED checking
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const [url, options] = args;
    
    if (url && (url.includes('/cart/add') || url.includes('cart/add.js'))) {
      console.log('🛒 FETCH INTERCEPTED - Starting detailed check');
      
      // Check if this fetch is from Quick View
      const activeQuickView = document.querySelector('quickbuy-canvas.active, .quick_shop-popup.active');
      if (activeQuickView) {
        console.log('ℹ️ Fetch from Quick View detected - letting Quick View validation handle it');
        return originalFetch.apply(this, args);
      }
      
      const validation = validateSizeSelection();
      
      // BLOCK if has size but not selected
      if (validation.needsValidation) {
        console.log('❌❌❌ BLOCKING FETCH - NO SIZE SELECTED!');
        showSizeAlert();
        
        // Return rejected promise
        return Promise.reject({
          message: 'Please select a size before adding to cart',
          blocked: true
        });
      }
      
      console.log('✅ Size validation passed - allowing fetch');
    }
    
    return originalFetch.apply(this, args);
  };
  
  // LAYER 2: Block button clicks IMMEDIATELY (Add to Cart + Buy Now)
  document.addEventListener('click', function(event) {
    const button = event.target.closest(
      'button[type="submit"], ' +
      '.product-form__submit, ' +
      'button[name="add"], ' +
      'button[name="buy_now"], ' +
      '.shopify-payment-button__button, ' +
      '[data-shopify-payment-button], ' +
      '.dynamic-checkout__button, ' +
      'button.buy-now, ' +
      'button[class*="buy-now"], ' +
      'button[class*="buynow"]'
    );
    
    if (button) {
      // Check if button is inside Quick View
      if (isInsideQuickView(button)) {
        console.log('ℹ️ Button click inside Quick View - letting Quick View validation handle it');
        return;
      }
      
      const form = button.closest('form');
      
      // Check if it's a product form or Buy Now button
      const isProductForm = form && (
        form.getAttribute('data-type') === 'add-to-cart-form' || 
        form.querySelector('input[name="id"]')
      );
      
      const isBuyNowButton = button.name === 'buy_now' || 
        button.classList.contains('buy-now') ||
        button.closest('.shopify-payment-button') ||
        button.closest('[data-shopify-payment-button]') ||
        button.classList.toString().includes('buy-now') ||
        button.classList.toString().includes('buynow');
      
      if (isProductForm || isBuyNowButton) {
        console.log('🔘 BUTTON CLICK DETECTED (outside Quick View)');
        console.log('Button type:', isBuyNowButton ? 'BUY NOW' : 'ADD TO CART');
        
        const validation = validateSizeSelection();
        
        if (validation.needsValidation) {
          console.log('❌❌❌ BLOCKING BUTTON CLICK - NO SIZE SELECTED!');
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          showSizeAlert();
          return false;
        }
        
        console.log('✅ Size validation passed - allowing button click');
      }
    }
  }, true);
  
  // LAYER 3: Block form submit
  document.addEventListener('submit', function(event) {
    const form = event.target;
    
    // Check if form is inside Quick View
    if (isInsideQuickView(form)) {
      console.log('ℹ️ Form submit inside Quick View - letting Quick View validation handle it');
      return;
    }
    
    if (form && (form.getAttribute('data-type') === 'add-to-cart-form' || form.querySelector('input[name="id"]'))) {
      console.log('📝 FORM SUBMIT DETECTED (outside Quick View)');
      
      const validation = validateSizeSelection();
      
      if (validation.needsValidation) {
        console.log('❌❌❌ BLOCKING FORM SUBMIT - NO SIZE SELECTED!');
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        showSizeAlert();
        return false;
      }
      
      console.log('✅ Size validation passed - allowing form submit');
    }
  }, true);
  
  // LAYER 4: Intercept Shopify's dynamic checkout (Buy Now) initialization
  if (window.Shopify && window.Shopify.PaymentButton) {
    console.log('🔍 Shopify Payment Button detected - adding validation');
    
    // Monitor for dynamic checkout button initialization
    const originalInit = window.Shopify.PaymentButton.init;
    if (originalInit) {
      window.Shopify.PaymentButton.init = function() {
        console.log('🛒 Shopify Payment Button initializing');
        const result = originalInit.apply(this, arguments);
        
        // Add validation to dynamically created buttons
        setTimeout(() => {
          document.querySelectorAll('.shopify-payment-button__button').forEach(btn => {
            if (!isInsideQuickView(btn) && !btn.hasAttribute('data-size-validated')) {
              btn.setAttribute('data-size-validated', 'true');
              btn.addEventListener('click', function(e) {
                const validation = validateSizeSelection();
                if (validation.needsValidation) {
                  e.preventDefault();
                  e.stopPropagation();
                  e.stopImmediatePropagation();
                  showSizeAlert();
                  return false;
                }
              }, true);
            }
          });
        }, 100);
        
        return result;
      };
    }
  }
  
  function showSizeAlert() {
    // Remove any existing alert
    const existing = document.querySelector('.size-alert-simple');
    if (existing) existing.remove();
    
    // Create simple alert (no backdrop, no white layer)
    const alert = document.createElement('div');
    alert.className = 'size-alert-simple';
    alert.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 999999;
      background: #FFFFFF;
      border: 2px solid #F9F6F0;
      border-radius: 8px;
      padding: 15px 25px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      display: flex;
      align-items: center;
      gap: 12px;
      color: #610F23;
      white-space: nowrap;
      font-size: 15px;
      font-weight: 600;
      max-width: 90%;
      animation: slideDown 0.3s ease;
    `;
    
    alert.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
        <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z"/>
      </svg>
      <span>👉 Please select a size before proceeding.</span>
    `;
    
    // Add slide animation
    if (!document.querySelector('#simple-alert-animation')) {
      const style = document.createElement('style');
      style.id = 'simple-alert-animation';
      style.textContent = `
        @keyframes slideDown {
          from { 
            opacity: 0;
            transform: translate(-50%, -20px);
          }
          to { 
            opacity: 1;
            transform: translate(-50%, 0);
          }
        }
      `;
      document.head.appendChild(style);
    }
    
    document.body.appendChild(alert);
    
    // Scroll to size field (only outside Quick View)
    setTimeout(() => {
      const sizeField = Array.from(document.querySelectorAll(
        'fieldset.product-form__input_size, ' +
        'input[name="Size"]'
      )).find(field => !isInsideQuickView(field));
      
      if (sizeField) {
        const container = sizeField.closest('fieldset, .product-form__input');
        if (container) {
          container.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }, 100);
    
    // Auto remove after 4 seconds
    setTimeout(() => {
      alert.style.opacity = '0';
      alert.style.transition = 'opacity 0.3s';
      setTimeout(() => alert.remove(), 300);
    }, 4000);
  }
  
  console.log('✅ Nuclear protection active - ALL layers engaged (Quick View aware + Buy Now support)');
})();

// DOM Ready initialization
document.addEventListener('DOMContentLoaded', function() {
  console.log('🔒 Initializing size validation on DOM ready');
  
  // Helper function to check if element is inside Quick View
  function isInsideQuickView(element) {
    return element.closest('quickbuy-canvas, .quick_shop-popup, [class*="quickview"]') !== null;
  }
  
  // Disable ALL variant inputs for products with size (excluding Quick View)
  const allVariantInputs = Array.from(document.querySelectorAll('input[name="id"]'))
    .filter(input => !isInsideQuickView(input));
  
  const hasSizeInputs = Array.from(document.querySelectorAll('input[name="Size"]'))
    .filter(input => !isInsideQuickView(input)).length > 0;
  const hasSizeSelects = Array.from(document.querySelectorAll('select[name*="Size"]'))
    .filter(select => !isInsideQuickView(select)).length > 0;
  
  if (hasSizeInputs || hasSizeSelects) {
    console.log('🔍 Product has size options - disabling variant inputs (excluding Quick View)');
    
    allVariantInputs.forEach((input, index) => {
      input.disabled = true;
      input.value = '';
      console.log(`🔒 Disabled variant input ${index}`);
    });
    
    // CRITICAL: Keep Buy Now buttons enabled but add validation
    const buyNowButtons = document.querySelectorAll(
      'button[name="buy_now"], ' +
      '.shopify-payment-button__button, ' +
      '[data-shopify-payment-button] button, ' +
      '.dynamic-checkout__button, ' +
      'button.buy-now, ' +
      'button[class*="buy-now"], ' +
      'button[class*="buynow"]'
    );
    
    buyNowButtons.forEach(btn => {
      if (!isInsideQuickView(btn)) {
        btn.disabled = false;
        btn.style.opacity = '1';
        btn.style.pointerEvents = 'auto';
        console.log('🔓 Buy Now button kept enabled for validation');
      }
    });
    
    // CRITICAL: Force remove ALL opacity and styling changes
    function removeOpacity() {
      // Remove opacity from all product elements (excluding Quick View)
      const elementsToFix = [
        'body', 'main', '#MainContent', '.main-content',
        'form[data-type="add-to-cart-form"]',
        '.product', '.product__item-js', '.main__product',
        'section[id*="MainProduct"]',
        '.product__info-wrapper', '.product__info-container', 'product-info',
        '.product-form', '.product-form__buttons', '.buy-btn-js',
        '.product__submit-form', '.product__submit-form-cart',
        'product-form', '.tablet-2', '.grid-cols',
        'button[type="submit"]', '.product_submit_button',
        // Buy Now button specific selectors
        '.shopify-payment-button', '.shopify-payment-button__button',
        '[data-shopify-payment-button]', '.dynamic-checkout__button'
      ];
      
      elementsToFix.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          // Skip if inside Quick View
          if (el && !isInsideQuickView(el)) {
            el.style.opacity = '1';
            el.style.filter = 'none';
            el.style.pointerEvents = 'auto';
            el.style.background = '';
          }
        });
      });
      
      // Specifically ensure Buy Now buttons are always enabled and clickable
      const buyNowButtons = document.querySelectorAll(
        'button[name="buy_now"], ' +
        '.shopify-payment-button__button, ' +
        '[data-shopify-payment-button] button, ' +
        '.dynamic-checkout__button'
      );
      
      buyNowButtons.forEach(btn => {
        if (!isInsideQuickView(btn)) {
          btn.disabled = false;
          btn.style.opacity = '1';
          btn.style.pointerEvents = 'auto';
          btn.style.cursor = 'pointer';
        }
      });
    }
    
    // Run immediately
    removeOpacity();
    
    // Run after short delay to catch dynamically loaded Buy Now buttons
    setTimeout(removeOpacity, 100);
    setTimeout(removeOpacity, 500);
    setTimeout(removeOpacity, 1000);
    setTimeout(removeOpacity, 2000);
    
    // Watch for any style changes (excluding Quick View)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const el = mutation.target;
          if (!isInsideQuickView(el) && el.style.opacity && el.style.opacity !== '1') {
            console.log('⚠️ Detected opacity change - fixing');
            el.style.opacity = '1';
            el.style.filter = 'none';
          }
        }
      });
    });
    
    // Observe main product areas (excluding Quick View)
    document.querySelectorAll('form[data-type="add-to-cart-form"], product-form, .product').forEach(el => {
      if (!isInsideQuickView(el)) {
        observer.observe(el, { 
          attributes: true, 
          attributeFilter: ['style'],
          subtree: true 
        });
      }
    });
    
    // Enable when size selected (excluding Quick View)
    document.addEventListener('change', function(e) {
      if (!isInsideQuickView(e.target) && (e.target.name === 'Size' || (e.target.name && e.target.name.includes('Size')))) {
        console.log('📝 Size changed:', e.target.value || e.target.checked);
        
        if (e.target.checked || e.target.value) {
          allVariantInputs.forEach(input => {
            input.disabled = false;
            console.log('✅ Enabled variant input');
          });
          
          // Ensure no opacity after selection
          removeOpacity();
          
          // Re-enable Buy Now buttons explicitly
          const buyNowButtons = document.querySelectorAll(
            'button[name="buy_now"], ' +
            '.shopify-payment-button__button, ' +
            '[data-shopify-payment-button] button, ' +
            '.dynamic-checkout__button'
          );
          
          buyNowButtons.forEach(btn => {
            if (!isInsideQuickView(btn)) {
              btn.disabled = false;
              btn.style.opacity = '1';
              btn.style.pointerEvents = 'auto';
            }
          });
        }
      }
    });
  }
});